<template>
  <div>
    <iframe
      class="iframe"
      ref="iframe"
      :src="frameUrl"
      width="100%"
      height="700px"
      id="iframe"
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
const judgeUrl = {
  localhost: 'http://127.0.0.1:3000',
  test: 'https://test.ytchenpi.com/print',
  product: 'https://www.ytchenpi.com/print',
}
export default {
  name: 'PrintBox',
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      frameUrl: '',

      origin: ['http://127.0.0.1', 'https://test.ytchenpi.com', 'https://www.ytchenpi.com/'],
      prodOrigin: ['https://test.ytchenpi.com', 'https://www.ytchenpi.com/'],
      lock: false, //锁
    }
  },
  mounted() {
    window.addEventListener('message', (eve) => {
      if (!this.lock) {
        this.lock = true //上锁

        this.origin.some((o) => {
          if (eve.origin.indexOf(o) > -1 || this.frameUrl.indexOf(eve.origin) > -1) {
            this.$emit('on-print', eve.data)
            return true
          }
        })

        setTimeout(() => {
          this.lock = false //解锁
        }, 2000)
      }
    })

    this.$on('hook:beforeDestroy', () => {
      window.removeEventListener('message', function () {})
    })
  },
  methods: {
    init(row) {
      var frame = document.getElementById('iframe').contentWindow
      frame.name = JSON.stringify(row)
      this.frameUrl = this.judgePrintUrlFun(row.type)
      frame.location.reload(true)
    },
    judgePrintUrlFun(type) {
      let url = window.location.href

      let currentUrl =
        (url.indexOf('localhost') > 0 && judgeUrl['localhost']) ||
        (url.indexOf('test.ytchenpi.com') > 0 && judgeUrl['test']) ||
        judgeUrl['product']

      return currentUrl + '/' + type + 'Print.html'
    },
  },
}
</script>

<style lang="less" scoped>
#printConcat {
  display: none;
}

@media print {
  #printConcat {
    display: block !important;
  }

  @page {
    size: auto;
    margin: 15mm 10mm;
    /*上下30mm页边距，左右20mm页边距*/
  }

  body,
  html {
    height: auto !important;
  }

  .pageFooter {
    position: relative;
    bottom: 20px;
  }

  #printConcat table {
    border-collapse: collapse;
    border-spacing: 0;
    margin: 5px auto;
    clear: both;
  }

  #printConcat li {
    list-style: none;
  }

  #printConcat .tableUl {
    overflow: hidden;
    padding: 0;
  }

  #printConcat table tr th {
    text-align: center;
    border: 1px solid #000;
    padding: 5px 2px;
  }

  #printConcat table tr td {
    padding: 0;
    margin: 0;
    text-align: left;
    padding: 5px 2px;
    border: 1px solid #000;
  }

  #printConcat header {
    font-size: 24px;
    text-align: center;
  }

  #printConcat header span {
    display: inline-block;
    padding: 0 10px;
    font-size: 36px;
  }

  #printConcat section ul {
    padding: 0;
  }

  #printConcat section ul li {
    float: left;
    width: 330%;
    font-size: 16px;
    padding: 5px 0;
  }

  #printConcat footer ul li {
    font-size: 16px;
    float: left;
    width: 25%;
  }

  #printConcat li.page {
    margin: 10px;
  }

  #printConcat .labor header {
    text-align: right;
  }

  #printConcat .pageFooter span {
    text-align: left;
    font-size: 12px;
    text-decoration: none;
    display: inline-block;
    padding-right: 80px;
    text-indent: 0;
    font-weight: normal;
  }
}

* {
  margin: 0;
  padding: 0;
}

#printConcat table {
  border-collapse: collapse;
  border-spacing: 0;
  margin: 5px auto;
  clear: both;
}

#printConcat li {
  list-style: none;
  padding: 10px 0;
}

#printConcat .tableUl {
  overflow: hidden;
  padding: 0;
}

#printConcat table tr th {
  text-align: center;
  font-weight: normal;
  border: 1px solid #000;
  padding: 2px;
}

#printConcat table tr td {
  padding: 0;
  margin: 0;
  text-align: center;
  padding: 2px;
  border: 1px solid #000;
}

#printConcat header {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
}

#printConcat header span {
  display: inline-block;
  padding: 0 10px;
  font-size: 36px;
}

#printConcat section ul {
  padding: 0;
  margin: 20px 0;
}

#printConcat section ul li {
  float: left;
  width: 33%;
  font-size: 16px;
  padding: 5px 0;
}

#printConcat ul.footer li {
  font-size: 16px;
  float: left;
  width: 50%;
  padding: 10px 0;
}

#printConcat ul.head li.first {
  font-size: 16px;
  font-weight: bold;
  float: left;
  width: 55%;
  padding: 10px 0;
}

#printConcat ul.head li.two {
  font-size: 16px;
  float: left;
  width: 45%;
  padding: 10px 0;
}

#printConcat span {
  text-decoration: underline;
}

#printConcat p,
#printConcat h3,
#printConcat ul {
  /* text-indent: 32px; */
  padding: 5px;
  line-height: 20px;
}

#printConcat .mech p,
#printConcat .mech p h3,
#printConcat .mech p ul {
  /*    text-indent: 32px; */
  padding: 5px 5px;
  line-height: 24px;
}

#printConcat .mech ul.head li.first {
  font-weight: normal;
}

#printConcat .labor header {
  text-align: right;
}

#printConcat .labor ul.head li.first {
  font-weight: 100;
  font-size: 18px;
}

#printConcat .labor header span {
  font-weight: 100;
  font-size: 18px;
}

#printConcat .mech h3 span,
#printConcat .loabor h3 span {
  font-weight: normal;

  font-size: 16px;
}

#printConcat .loabor h3 span {
  text-decoration: none;
}

#printConcat li.page {
  margin: 10px;
}

#printConcat .pageFooter span {
  text-align: left;
  font-size: 12px;
  text-decoration: none;
  display: inline-block;
  padding-right: 80px;
  text-indent: 0;
  font-weight: normal;
}
</style>
